(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealGroups = [
    {
      selector: [
        '[class*="cruise-hero-"][class*="__content"]',
        '[class*="cruise-countdown-"][class*="__inner"]',
        '[class*="cruise-specs-"][class*="__column"]',
        '[class*="cruise-steps-"][class*="__header"]',
        '[class*="cruise-quick-"][class*="__header"]',
        '[class*="cruise-products-"][class*="__header"]',
        '[class*="cruise-faq-"][class*="__heading"]',
      ].join(','),
      mode: 'soft',
      delay: 90,
    },
    {
      selector: [
        '[class*="cruise-steps-"][class*="__step"]',
        '[class*="cruise-quick-"][class*="__card"]',
        '[class*="cruise-products-"][class*="__card"]',
        '[class*="cruise-faq-"][class*="__item"]',
      ].join(','),
      mode: 'lift',
      delay: 70,
    },
  ];

  function prepareElements() {
    const prepared = [];

    revealGroups.forEach((group) => {
      document.querySelectorAll(group.selector).forEach((element, index) => {
        if (!(element instanceof HTMLElement) || element.dataset.scrollRevealReady === 'true') return;

        const delay = Math.min(index, 8) * group.delay;

        element.dataset.scrollReveal = group.mode;
        element.dataset.scrollRevealReady = 'true';
        element.style.setProperty('--scroll-reveal-delay', `${delay}ms`);
        prepared.push(element);
      });
    });

    return prepared;
  }

  function revealImmediately(elements) {
    elements.forEach((element) => element.classList.add('is-visible'));
  }

  function observe(elements) {
    if (!('IntersectionObserver' in window)) {
      revealImmediately(elements);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.16,
      }
    );

    elements.forEach((element) => observer.observe(element));
  }

  function init() {
    document.documentElement.classList.add('scroll-effects-ready');

    const elements = prepareElements();
    if (reducedMotion) {
      revealImmediately(elements);
      return;
    }

    observe(elements);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
